import React from 'react';
import { formatBytesToMB } from '@utils/formatBytes';
import { useTranslation } from 'react-i18next';

interface UploadProgressProps {
  transferredBytes: number;
  totalBytes: number;
  showProgress: boolean;
}

export function UploadProgress({ transferredBytes, totalBytes, showProgress }: UploadProgressProps) {
  const { t } = useTranslation();

  if (!showProgress) {
    return null;
  }

  return (
    <>
      <h2>{t('upload.uploadProgress')}</h2>
      <p role="status" aria-live="polite">
        {totalBytes > 0 
          ? t('upload.encryptedAndSent', { 
              transferred: formatBytesToMB(transferredBytes, 2, t), 
              total: formatBytesToMB(totalBytes, 2, t) 
            }) + '.'
          : formatBytesToMB(transferredBytes, 2, t) + '.'}
      </p>
    </>
  );
}
